module.exports = __webpack_public_path__ + "media/8.60f0fb3d.mp3";